enum cardActions {
  deleteCards = "DeleteCards",
  createCards = "CreateCards",
  updateCards = "UpdateCards"
}

export {
  cardActions
}
